import React, { Component } from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import Icons from '../../Icons/Icons';
import { LinkContainer } from 'react-router-bootstrap';
import ConfirmBox from '../../../hoc/ConfirmBox';
import { isSet } from '../../../Utils/CommonFunctions';

class Buttons extends Component {
    state = {
        buttonList:this.props.buttonList,
        isConfirmBoxOpen:false,
        buttonData:null,
        content:'',
        event:''
      }
    defaultOnclickHandler(){
      // alert('sss');
    }
    componentDidUpdate(prevProps){
      if(prevProps.buttonList !== this.props.buttonList) {
        this.setState({buttonList:this.props.buttonList});
      }
    }

    toggleConfirmBox = (item) => {
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen,buttonData:item,content:item.content});
    }
    confirmDelete =(item, e)=>{
      if (e && typeof e.persist === 'function') {
        e.persist();
      }
      this.setState({
        isConfirmBoxOpen:!this.state.isConfirmBoxOpen,
        buttonData:item,
        content:isSet(
          item?.data?.action_component?.confirmation_message,
          isSet(item?.data?.confirmation_message, "")
        ),
        event: e || ''
      })
    }

    /** Pages (and other special types) should behave like Edit — not the hardcoded Delete confirm. */
    isPagesConfiguredButton = (item) => {
      const ac = item?.data?.action_component || item?.data;
      const type = Number(ac?.button_type);
      if (type !== 11) {
        return false;
      }
      const pagesId = ac?.pages_config_setup_id || ac?.pages_configuration_setup_id || ac?.pagesConfigurationSetupId;
      return pagesId !== undefined && pagesId !== null && pagesId !== '' && pagesId !== 0 && pagesId !== '0';
    }
    // confirmButtonClick = () => {
    //   // console.log(this.state.buttonData.clickHandler())
    //   this.state.buttonData.clickHandler();
    //   this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen,buttonData:null,content:''});
    // }
    openConfirmBox =()=>{
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen,buttonData:null,content:''})
    }
    confirmButtonClick = () => {
      this.state.buttonData.clickHandler(this.state.event);
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen,buttonData:null,content:'',event:''});
    }

    render () {
      return (
        <Wrp>
          <style>{`
            .delete-button-disabled:hover .no-symbol-overlay {
              display: flex !important;
            }
          `}</style>
          {/*<span className="webViewMenu">
            { this.buttonListHtml(this.state.buttonList,'btn') }
          </span>          
          <span className="mobileViewMenu">
            <div className="btn-group">
            <a className="btn border-default dropdown-toggle hidden-caret btn-border dropdown-menu-right ml-1 mr-1" data-toggle="dropdown" aria-expanded="false">
            <Icons iconType={'EllipsisV'} />
            </a>
            <span className="dropdown-menu dropdown-menu-right" style={{position:'absolute',transform: 'translate3d(-44px, 33px, 0px)', top: '0px',left: '0px',zIndex:'9999',willChange: 'transform'}}>
            { this.buttonListHtmlMobile(this.state.buttonList,'btn') }
            </span>
            </div>
          </span>*/}
          { this.buttonListHtml(this.state.buttonList,'btn') }

          
          <ConfirmBox
            isConfirmBoxOpen={this.state.isConfirmBoxOpen}
            toggleConfirmBox={this.toggleConfirmBox}
            confirmButtonClick={this.confirmButtonClick}
            content={this.state.content}
          />     
        </Wrp>
      )
    }

    

    buttonListHtml = (buttonList,id)=>{
      // console.log("buttonList",buttonList);
      return buttonList.map((item, i) => {
        if(item!=undefined){
          if(item.isButtonGroup && item.isButtonGroup===true){
            let inlineStyle = (item.style)?{...item.style}:{};
            return(
              <div className={item.className} style={inlineStyle} key={i}>
                {this.buttonListHtml(item.list,'buttonGroup')}
              </div>
            )
          }else if(item.isParentElement && item.isParentElement===true){
            return item.parentElement
          }else{
            return(
              (item.access_mode === undefined || item.access_mode === true) ?
                this.singleButtons(item,id+'_'+i)
              : null
            )
          }
        }
        
      });
    }
    isConfirmPopup=(item,e)=>{ 
      e.persist();
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen,buttonData:item,content:item.data.action_component.confirmation_message||"",event:e})
    }
    dropDownButtons = (dropDownItem,i)=>{
      let inlineStyle = (dropDownItem.style)?{...dropDownItem.style}:{};
      let style = {...inlineStyle}
      return(
        <span {...dropDownItem.attributes} style={style}>
            {this.buttonListHtml(dropDownItem.buttonList,i)}
        </span>
      )
    }
    
    singleButtons = (item,i)=>{
      const buttonIconClass = {
        cancel:"",
        save:"",
        edit:"Edit",
        createNew:"",
        addNew:"AddPlus",
        delete:"Delete",
        email:"EmailSettings"
     }
      const href = (item.href) ? item.href: "#";
      const ac = item?.data?.action_component || item?.data;
      const confirm=isSet(ac?.is_confirmation_popup)===true?true:false
      const isPagesButton = this.isPagesConfiguredButton(item);
          const eventsHandler = {
            onClick:  (item.clickHandler) && confirm ?this.isConfirmPopup.bind(this,item,):(item.clickHandler) ? item.clickHandler : this.defaultOnclickHandler.bind(),
          }
          let inlineStyle = (item.style)?{...item.style}:{};
          
          let style = (item.disabled) ? {pointerEvents:'none',opacity:'0.7', cursor:'not-allowed'}:{}
          style = {...inlineStyle,...style}
          const isDeleteButton = (isSet(item.isConfirm,false)===true || item.svgIcon && item.svgIcon.toLowerCase() === 'delete') || (item.type && item.type.toLowerCase() === 'delete') || (item.name && item.name === 'Delete');
          // Pages Delete must run like Edit (clickHandler / optional confirm flag) — not hardcoded ConfirmBox.
          const useHardcodedDeleteConfirm = isDeleteButton && !isPagesButton && !!item.clickHandler;
          const showNoSymbol = isDeleteButton && !!item.disabled;
          const linkContainerStyle = showNoSymbol ? {...style, position: 'relative', display: 'inline-block', cursor:'not-allowed'} : style;
      return(
        <Wrp key={'wrp'+i}>    
          { //DELETE KEY (default Action delete only)
            (useHardcodedDeleteConfirm) ?
              <LinkContainer key={i} to={href} onClick={item.disabled ? (e) => { e.preventDefault(); e.stopPropagation(); } : (e)=>this.confirmDelete(item, e)} {...item.attributes} style={linkContainerStyle}>
                <a style={{
                  ...style, 
                  position: showNoSymbol ? 'relative' : 'static', 
                  display: 'inline-block',
                  cursor: item.disabled ? 'not-allowed' : 'pointer'
                }} key={`keya-${i}`}>
                  <span 
                    className={showNoSymbol ? 'delete-button-disabled' : ''}
                    style={{ position: 'relative', display: 'inline-block' }}
                  >
                    {(item.iconClass && item.iconClass!=='' && item.iconClass!==undefined)?
                        <Wrp><i className={item.iconClass}></i></Wrp>
                    :(item.svgIcon && item.svgIcon!=='' && item.svgIcon!==undefined)?
                      <Icons iconType={item.svgIcon} />
                    :(buttonIconClass[item.type]!=="" && buttonIconClass[item.type]!==undefined) ?  
                        <Icons iconType={buttonIconClass[item.type]} />
                    :""}
                    {showNoSymbol && (
                      <span 
                        className="no-symbol-overlay"
                        style={{
                          position: 'absolute', 
                          top: '50%', 
                          left: '50%', 
                          transform: 'translate(-50%, -50%)', 
                          zIndex: 1000,
                          width: '22px',
                          height: '22px',
                          display: 'none',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'white',
                          borderRadius: '50%',
                          border: '1px solid #ccc',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
                        }}
                      >
                        <Icons iconType="Cross" size={14} />
                      </span>
                    )}
                  </span>
                  {item.name}{item.access_mode}
                </a>
              </LinkContainer>
            : <LinkContainer key={i} to={href} {...eventsHandler} {...item.attributes} style={isDeleteButton ? linkContainerStyle : style}>
                {
                  item.nameBeforeIcon && item.nameBeforeIcon === true ?
                    <a style={style} key={`keyb-${i}`}>
                      {item.name}{item.access_mode} 
                      {(item.iconClass && item.iconClass!=='' && item.iconClass!==undefined)?
                          <Wrp><i className={item.iconClass}></i> </Wrp>
                      :(item.svgIcon && item.svgIcon!=='' && item.svgIcon!==undefined)?
                        <Icons iconType={item.svgIcon} />
                      :(buttonIconClass[item.type]!=="" && buttonIconClass[item.type]!==undefined) ?  
                          <Icons iconType={buttonIconClass[item.type]} />
                      :""}
                    </a>
                  :
                  <a style={style} key={`keyc-${i}`}>
                    {(item.iconClass && item.iconClass!=='' && item.iconClass!==undefined)?
                        <Wrp><i className={item.iconClass}></i> </Wrp>
                    :(item.svgIcon && item.svgIcon!=='' && item.svgIcon!==undefined)?
                      <Icons iconType={item.svgIcon} />
                    :(buttonIconClass[item.type]!=="" && buttonIconClass[item.type]!==undefined) ?  
                        <Icons iconType={buttonIconClass[item.type]} />
                    :""}
                    {item.name}{item.access_mode}
                  </a>
                }
                
              </LinkContainer>
          }      
          
          {(item.children)?
              this.dropDownButtons(item.children,'dropDown'+i)
          :''}     
       </Wrp> 
      )
    }

    /*Mobile View Code Start*/
    buttonListHtmlMobile = (buttonList,id)=>{
      return buttonList.map((item, i) => {
        if(item.isButtonGroup && item.isButtonGroup===true){
          // let inlineStyle = (item.style)?{...item.style}:{};
          return(
            this.buttonGroupListHtmlMobile(item.list,'buttonGroup')
          )
        }else if(item.isParentElement && item.isParentElement===true){
          return item.parentElement
        }else{
          return(
            (item.access_mode === undefined || item.access_mode === true) ?
              this.singleButtonsMobile(item,id+'_'+i,'web')
            : null
          )
        }
      });
    }

    buttonGroupListHtmlMobile = (buttonList,id)=>{
      return buttonList.map((item, i) => {
        if(item.children && item.children.buttonList && item.children.buttonList.length > 0){
          // let inlineStyle = (item.style)?{...item.style}:{};
          return(
            this.buttonListHtmlMobile(item.children.buttonList,'buttonGroup')
          )
        }
      });
    }

    singleButtonsMobile = (item,i)=>{
      // const buttonIconClass = {
      //   cancel:"",
      //   save:"",
      //   edit:"Edit",
      //   createNew:"",
      //   addNew:"AddPlus",
      //   delete:"Delete",
      //   email:"EmailSettings"
      // }
      const href = (item.href) ? item.href: "#";
      const eventsHandler = {
        onClick: (item.clickHandler) ? item.clickHandler : this.defaultOnclickHandler.bind(),
      }
      let inlineStyle = (item.style)?{...item.style}:{};
      
      let style = (item.disabled) ? {pointerEvents:'none',opacity:'0.7'}:{}
      style = {...inlineStyle,...style}
      return(
        <Wrp key={'wrp'+i}>          
          <LinkContainer key={i} to={href} {...eventsHandler} {...item.attributes} className="dropdown-item" style={style}>
            {
              <a safdsaf={item.name} key={`keyd-${i}`}>
                {item.name === '' ? item.toolTip : item.name}{item.access_mode}
              </a>
            }
          </LinkContainer>
                 
       </Wrp> 
      )
    }
    /*Mobile View Code End*/
    
}
Buttons.defaultProps = {
  iconClass: '',
  svgIcon: ''
}

export default Buttons;